import { motion } from "framer-motion";
import { Sun } from "lucide-react";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const Header = () => {
  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-stone-950/60 border-b border-white/10"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 h-16 flex items-center justify-between">
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-2 group"
          data-testid="logo-button"
        >
          <span className="w-8 h-8 rounded-full bg-amber-400 flex items-center justify-center transition-transform duration-300 group-hover:rotate-90">
            <Sun className="w-4 h-4 text-stone-950" />
          </span>
          <span className="font-serif text-xl tracking-tight text-stone-50">LumaDeck</span>
        </button>

        <nav className="hidden md:flex items-center gap-8 text-xs uppercase tracking-[0.2em] text-stone-400">
          {[
            ["Story", "manifesto"],
            ["Features", "features"],
            ["How it works", "how-it-works"],
            ["Spaces", "gallery"],
          ].map(([label, id]) => (
            <button
              key={id}
              onClick={() => scrollTo(id)}
              className="hover:text-amber-400 transition-colors duration-300"
              data-testid={`nav-${id}`}
            >
              {label}
            </button>
          ))}
        </nav>

        <button
          onClick={() => scrollTo("order")}
          className="rounded-full bg-amber-400 text-stone-950 px-5 py-2 text-sm font-medium transition-transform duration-300 hover:scale-105"
          data-testid="header-buy-button"
        >
          Buy — ₹1,499
        </button>
      </div>
    </motion.header>
  );
};
